import {initAccountInfo} from "./../actions/AccountInfoActions";

export const setAccountInfo = data => {
    return dispatch => {
        dispatch(initAccountInfo(data));
    }
}